import React, { useState } from 'react'
import { Button, Form, Input, message, Typography } from 'antd'
import styles from '../unlogined/signIn.module.css'
import { restoreVerify } from '../../api/account'
import { useLocation } from 'react-router'

export const RestoreVerify = (): React.ReactElement => {
	const [form] = Form.useForm()
	const [loading, setIsLoading] = useState(false)
	const link = new URLSearchParams(useLocation().search).get('link')

	async function onFinish({ password } : { password: string }) {
		const res = await restoreVerify(link ? link : '', password)

		if (res.success) {
			void message.success('Пароль успешно изменён!')

			form.resetFields()
		} else {
			void message.error(res.message)
		}
	}

	return (
		<div className={styles['container']}>
			<Form
				className={styles['sign-in-block']}
				layout="vertical"
				form={form}
				onFinish={values => {
					setIsLoading(true)
					void onFinish(values)
				}}
			>
				<Typography.Title level={3} style={{ marginBottom: '25px' }}>
					Изменение пароля
				</Typography.Title>

				<Form.Item
					name="password"
					label="Пароль"
					rules={[{ required: true, message: 'Данное поле обязательно!' }]}
				>
					<Input.Password
						placeholder="Введите в это поле пароль"
					/>
				</Form.Item>

				<Form.Item name="submit" style={{ marginTop: '20px' }}>
					<Button htmlType="submit" type="primary" loading={loading}>
						Изменить пароль
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}

export const routePathRestoreVerify = '/verify/restore'
